function initVatToggle() {
  const leftContent = document.querySelector('.left-content');
  const leftContentSpan = document.querySelector('.left-content span');
  const rightContent = document.querySelector('.right-content');

  if (!leftContent) return;

  if (rightContent) rightContent.style.display = 'none';
  if (leftContentSpan) {
    leftContentSpan.textContent = 'incl. VAT';
    leftContentSpan.style.setProperty('color', '#fff', 'important');
  }

  const classObserver = new MutationObserver(() => {
    leftContentSpan.textContent = leftContent.classList.contains('active') ? 'excl. VAT' : 'incl. VAT';
    leftContentSpan.style.setProperty('color', '#fff', 'important');
  });

  classObserver.observe(leftContent, { attributeFilter: ['class'] });

  return classObserver;
}

function resetVatToggle() {
  const leftContentSpan = document.querySelector('.left-content span');
  const rightContent = document.querySelector('.right-content');

  if (rightContent) rightContent.style.display = 'block';
  if (leftContentSpan) {
    leftContentSpan.textContent = 'excl. VAT';
    leftContentSpan.style.color = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let classObserver = null;

  function handleResize() {
    if (window.innerWidth <= 576) {
      if (!classObserver) {
        classObserver = initVatToggle();
      }
    } else {
      if (classObserver) {
        classObserver.disconnect();
        classObserver = null;
      }
      resetVatToggle();
    }
  }

  if (document.querySelector('.left-content')) {
    handleResize();
  } else {
    const domObserver = new MutationObserver((mutations, obs) => {
      if (document.querySelector('.left-content')) {
        obs.disconnect();
        setTimeout(handleResize, 300);
      }
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('resize', debounce(handleResize, 200));
});